import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import cl from './languages/cl.json';
import pe from './languages/pe.json';

import { market } from '../../constants';

const resources = { cl, pe };

i18n.use(initReactI18next).init({
  resources,
  lng: market,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
